// extracted by mini-css-extract-plugin
module.exports = {"container":"slider-thumbs_container__sSQF8","img":"slider-thumbs_img__kRKvm","selected":"slider-thumbs_selected__rIrX_"};